import { useRef, useState } from 'react';
import { useTranslation } from "react-i18next";
import { Panel } from 'primereact/panel';
import { Button } from 'primereact/button';
import { useGlobalState } from '../../../components/globalState/GlobalStateProvider';
import { FilterWeb } from '../../../interface/FilterWeb';
import { InputText } from 'primereact/inputtext';
import { RadioButton } from 'primereact/radiobutton';
import getFiltroPermissao from '../../../service/getFiltroPermissao';
import { Dialog } from 'primereact/dialog';
import React from 'react';
import { Messages } from 'primereact/messages';
import { Tree, TreeCheckboxSelectionKeys, TreeMultipleSelectionKeys } from 'primereact/tree';

export default function FiltroNome({
    onProcess,
    onClose
  }: {
    onProcess: (filterWeb : FilterWeb, semDocumento: boolean) => void
    onClose: () => void
  }) {
  const { t } = useTranslation();
  const {state} = useGlobalState();
  const [nome, setNome] = useState<string>("");
  const [uf, setUf] = useState<string>("");
  const [cidade, setCidade] = useState<string>("");
  const [selectedFilter, setSelectedFilter] = useState<any>();
  const [filtros, setFiltros] = useState<any[]>([]);
  const msgs = useRef<Messages>(null);
  const [selectedKeys, setSelectedKeys] = useState<string | TreeMultipleSelectionKeys | TreeCheckboxSelectionKeys | any | null>(null);

  const mensagemErroFiltro = (mensagem : string) => {
    window.scrollTo(0, 0);
    msgs.current?.clear();
      msgs.current?.show([
          { sticky: false, life: 100000, severity: 'error', summary: 'Erro', detail: mensagem, closable: false }

      ]);
  }

  const changeFilter = (value:any) => {
    getFiltroPermissao(value.key).then((data) => {
      setSelectedFilter(value);
      setFiltros(data);
    })
  }

  const validFiltro = (filteWeb :FilterWeb, filtro:any) => {
    if(filtro.tipoFiltro.includes("NOME") && filtro.obrigatorio && !filteWeb.nome){
      return false;
    }
    if(filtro.tipoFiltro.includes("UF") && filtro.obrigatorio && !filteWeb.uf){
      return false;
    }
    if(filtro.tipoFiltro.includes("CIDADE") && filtro.obrigatorio && !filteWeb.cidade){
      return false;
    }
    return true;
  }

  const valid = (filteWeb :FilterWeb) => {
    if(filteWeb.consultas.length === 0){
       mensagemErroFiltro('Opções de consulta obrigatório')
       return false;
    }
    if(!filteWeb.nome){
      mensagemErroFiltro('Nome obrigatório')
      return false;
    }
    let retorno = true;
    filtros.forEach((filtro:any) => {
      if(!validFiltro(filteWeb, filtro)){
        mensagemErroFiltro(filtro.descricao + ' obrigatório');
        retorno = false;
        return false;
      }
    })

    return retorno;
  }

  const processConsulta = () => {

    let opcoes: string[] = [];
    if(selectedFilter){
      opcoes.push(selectedFilter.key);
    }

    const filteWeb :FilterWeb = {
      documento: "",
      consultas: opcoes,
      valor: null,
      arrojado: null,
      usual:null,
      conservador: null,
      indicadores: [],
      nome: nome,
      uf: uf,
      cidade: cidade
    };
    if(valid(filteWeb)){
      onProcess(filteWeb, true);
    }

  }

const createOptions = () =>{
  const option : any[] = [];

  state.user.consultas.filter((f: {
    permissoes: any;
    tipoConsulta: string;
  }) => f.tipoConsulta ===  'NOME')
  .sort( (a:any,b:any) => {
      if(!a.ordenacao){
        return 1;
      }

      if(!b.ordenacao){
        return -1;
      }

      if (a.ordenacao > b.ordenacao) {
        return 1;
      }
      if (a.ordenacao < b.ordenacao) {
        return -1;
      }
      return 0;
  } )
  .forEach((element: any) => {
      const filhos = element.permissoes ? element.permissoes.filter((f: {
        tipoConsulta: string;
      }) => f.tipoConsulta ===  'NOME') : [];
      if(filhos.length > 0){
        option.push({label:element.label, informativo: element.informativo, key:element.value, Collapse:true, children: element.permissoes ? createPermissoesFilhos(filhos) : []});
      }

    });
          expandAll(option)
  return option;
}

const expandNode = (node:any, _expandedKeys:any) => {
  if (node.children && node.children.length) {
      _expandedKeys[node.key] = true;

      for (let child of node.children) {
          expandNode(child, _expandedKeys);
      }
  }
};

const expandAll = (option:any) => {
  let _expandedKeys = {};

  for (let node of option) {
      expandNode(node, _expandedKeys);
  }

 return _expandedKeys;
};

const createPermissoesFilhos = (permissoes:any[]) => {
  const option : any[] = [];
  if(permissoes){
    permissoes
    .sort( (a:any,b:any) => {
        if(!a.ordenacao){
          return 1;
        }

        if(!b.ordenacao){
          return -1;
        }

        if (a.ordenacao > b.ordenacao) {
          return 1;
        }
        if (a.ordenacao < b.ordenacao) {
          return -1;
        }
        return 0;
    } )
    .forEach((element: {
      children: any; label: string; informativo: string; value: string; permissoes:any[]
    }) => {

      option.push({label:element.label, informativo: element.informativo, key:element.value, Collapse:true, children: element.permissoes ? createPermissoesFilhos(element.permissoes.filter((f: {
        tipoConsulta: string;
      }) => f.tipoConsulta === 'NOME')) : []});
    });
  }
  return option;
}
const nodeTemplate = (node: any, options: { className: string | undefined; }) => {
  let label = <span><RadioButton inputId={node.key} name="filter" value={node} onChange={(e) => changeFilter(e.value)} checked={selectedFilter?.key === node.key} /><label htmlFor={node.key} className="ml-2">{node.label}</label>{node.informativo && ( <i data-pr-tooltip={node.informativo} data-pr-position="right" data-pr-at="right+5 top" style={{paddingLeft: '1.5rem', color: '#183462', fontSize: '1.2rem'}} className="custom-target-icon pi pi-question-circle"></i>)}</span>;
  if (node.children.length !== 0) {
     label = <b>{node.label}</b>;
  }

  return label;
}
const footerContent = (
  <React.Fragment>
        <Button style={{marginRight:"1rem", backgroundColor:'#183462'}} label="Consultar"  onClick={processConsulta} />
        <Button label="Fechar" icon="pi pi-times" style={{color:'#183462'}} onClick={() => setFiltros([])} className="p-button-text" />
  </React.Fragment>
  );



  return (<>
    <Panel header={t('consultaCadastralNome')}>
        <div className=" p-fluid flex flex-wrap gap-3">
          <Tree filter filterMode="lenient" nodeTemplate={nodeTemplate} expandIcon={undefined} collapseIcon={undefined} expandedKeys = {expandAll(createOptions())} value={createOptions()} selectionMode="single" selectionKeys={selectedKeys} onSelectionChange={(e) => {setSelectedKeys(e.value);  }} style={{border:'none', marginLeft:'-2.0rem', background:'transparent'}}  />
        </div>

    </Panel>
    <Dialog header={selectedFilter?.label} visible={filtros.length > 0} style={{ width: '80vw' }} onHide={() => setFiltros([])} footer={footerContent}>
      <Messages ref={msgs} />

      <div className="flex-auto">
        <label htmlFor="nome" className="font-bold block mb-2 required">Nome</label>
        <InputText id="nome" value={nome} onChange={(e)=>{setNome(e.target.value);}}  placeholder="Nome completo" required></InputText>
      </div>
      <br></br>

      {filtros.filter((s1:any) => s1.tipoFiltro === 'UF').length > 0 && (
        <>
          <div className="flex-auto">
            <label htmlFor="uf" className={filtros.filter((s1:any) => s1.tipoFiltro === 'UF')[0].obrigatorio ? 'font-bold block mb-2 required' : 'font-bold block mb-2'}>UF</label>
            <InputText id="uf" value={uf} onChange={(e)=>{setUf(e.target.value);}}  placeholder="UF" maxLength={2} required></InputText>
          </div>
          <br></br>
        </>
      )}

      {filtros.filter((s1:any) => s1.tipoFiltro === 'CIDADE').length > 0 && (
        <>
          <div className="flex-auto">
            <label htmlFor="cidade" className={filtros.filter((s1:any) => s1.tipoFiltro === 'CIDADE')[0].obrigatorio ? 'font-bold block mb-2 required' : 'font-bold block mb-2'}>Cidade</label>
            <InputText id="cidade" value={cidade} onChange={(e)=>{setCidade(e.target.value);}}  placeholder="Cidade" required></InputText>
          </div>
          <br></br>
        </>
      )}

    </Dialog>
    </>
  )
}
